
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__event__",
      function () {
        return require("private-next-pages/__event__/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__event__"])
      });
    }
  